import moment from 'moment';
import { useCallback, useMemo } from 'react';
import { colors } from '../../../../../../../colors';
import {
  formatBalance,
  formatPrice,
} from '../../../../../../../helpers/NumberFormatter';
import { CustomTransaction } from 'grts-utils/types/Transaction';
import TransactionItemStructure from '../../../../../../../components/TransactionItem';

interface Props {
  transaction: CustomTransaction;
  index: number;
  totalLength: number;
}

const CustomTransactionItem: React.FC<Props> = (props: Props) => {
  const { transaction, index, totalLength } = props;

  const getTransactionType = useCallback((transactionType: string) => {
    if (transactionType.indexOf('ADD_STABLE') !== -1) {
      return 'Add Stable Balance';
    }

    if (transactionType.indexOf('ADD_ASSET') !== -1) {
      return 'Add Asset Balance';
    }

    if (transactionType.indexOf('REMOVE_STABLE') !== -1) {
      return 'Remove Stable Balance';
    }

    if (transactionType.indexOf('REMOVE_ASSET') !== -1) {
      return 'Remove Asset Balance';
    }

    return 'Unknown';
  }, []);

  const labelAbbreviation = useMemo(() => {
    if (transaction.transactionType.indexOf('ADD') !== -1) {
      return 'A';
    }

    if (transaction.transactionType.indexOf('REMOVE') !== -1) {
      return 'R';
    }

    return '?';
  }, [transaction.transactionType]);

  return (
    <TransactionItemStructure
      circleLabel={labelAbbreviation}
      circleColor={'rgb(7, 72, 121)'}
      circleSize={70}
      date={moment(transaction.transactionTimestamp).format('D MMM YYYY HH:mm')}
      contentWidth="auto"
      content={
        <div
          className="detail-transactions-item-info-container-row"
          style={{ padding: 16, paddingLeft: 32, paddingRight: 32 }}
        >
          <div className="detail-transactions-item-info-container-column">
            <div className="detail-transactions-item-info-container-value-container">
              <span className="detail-transactions-item-info-container-value-label">
                Stable quantity:
              </span>
              <span className="detail-transactions-item-info-container-value-text">
                {formatBalance(transaction.stableQuantity)}
              </span>
            </div>
            <div className="detail-transactions-item-info-container-value-container">
              <span className="detail-transactions-item-info-container-value-label">
                Stable Balance:
              </span>
              <span className="detail-transactions-item-info-container-value-text">
                {formatBalance(transaction.currentStableBalance)}
              </span>
            </div>
            <div className="detail-transactions-item-info-container-value-container">
              <span className="detail-transactions-item-info-container-value-label">
                Current Price:
              </span>
              <span className="detail-transactions-item-info-container-value-text">
                {formatPrice(transaction.currentPrice ?? 0)}
              </span>
            </div>
          </div>

          <div className="detail-transactions-item-info-container-column">
            <div className="detail-transactions-item-info-container-value-container">
              <span className="detail-transactions-item-info-container-value-label">
                Asset quantity:
              </span>
              <span className="detail-transactions-item-info-container-value-text">
                {formatBalance(transaction.assetQuantity, false)}
              </span>
            </div>
            <div className="detail-transactions-item-info-container-value-container">
              <span className="detail-transactions-item-info-container-value-label">
                Asset Balance:
              </span>
              <span className="detail-transactions-item-info-container-value-text">
                {formatBalance(transaction.currentAssetBalance, false)}
              </span>
            </div>

            <div className="detail-transactions-item-info-container-value-container">
              <span className="detail-transactions-item-info-container-value-label">
                Transaction Type:
              </span>
              <span
                className="detail-transactions-item-info-container-value-text"
                style={{
                  color:
                    transaction.transactionType.indexOf('REMOVE') !== -1
                      ? colors.red
                      : colors.green,
                }}
              >
                {getTransactionType(transaction.transactionType)}
              </span>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default CustomTransactionItem;
